import type { ReactNode } from "react";
import PageLayout from "./layout";

export default function (): ReactNode {
  return (
    <PageLayout title="NewsRPM Marketplace">
      <section>
        <h2>NewsRPM Marketplace</h2>
        <p>Please select a component to manage</p>
      </section>
    </PageLayout>
  );
}
